// Página de seleção de tipo de nota fiscal
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/common/Card';
import { Button } from '../../components/common/Button';
import { Breadcrumbs } from '../../components/layout/Breadcrumbs';
import { FileText, Receipt, CreditCard } from 'lucide-react';

export function Emissao() {
  const navigate = useNavigate();
  
  const tiposNota = [
    {
      id: 'nfe',
      nome: 'NFe',
      descricao: 'Nota Fiscal Eletrônica',
      descricaoCompleta: 'Emita notas fiscais de produtos para empresas em todo o Brasil.',
      icon: FileText,
      path: '/app/emissao/nfe',
      cor: 'bg-blue-500',
      corHover: 'hover:bg-blue-600',
    },
    {
      id: 'nfse',
      nome: 'NFSe',
      descricao: 'Nota Fiscal de Serviços Eletrônica',
      descricaoCompleta: 'Emita notas fiscais de serviços para clientes em todo o Brasil.',
      icon: Receipt,
      path: '/app/emissao/nfse',
      cor: 'bg-green-500',
      corHover: 'hover:bg-green-600',
    },
    {
      id: 'nfce',
      nome: 'NFCe',
      descricao: 'Nota Fiscal de Consumidor Eletrônica',
      descricaoCompleta: 'Emita notas fiscais para consumidores finais em vendas presenciais.',
      icon: CreditCard,
      path: '/app/emissao/nfce',
      cor: 'bg-purple-500',
      corHover: 'hover:bg-purple-600',
    },
  ];
  
  return (
    <div className="space-y-6">
      <Breadcrumbs items={[{ label: 'Emissão' }]} />
      
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Emissão de Notas Fiscais</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Selecione o tipo de nota fiscal que deseja emitir
          </p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tiposNota.map((tipo) => {
          const Icon = tipo.icon;
          return (
            <div
              key={tipo.id}
              className="cursor-pointer"
              onClick={() => navigate(tipo.path)}
            >
              <Card className="hover:shadow-lg transition-shadow h-full">
                <div className="flex flex-col items-center text-center p-6">
                  <div className={`w-16 h-16 ${tipo.cor} rounded-full flex items-center justify-center mb-4 transition-transform hover:scale-110`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">
                    {tipo.nome}
                  </h3>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-2">
                    {tipo.descricao}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-500 mb-4">
                    {tipo.descricaoCompleta}
                  </p>
                  <Button
                    variant="primary"
                    className={`w-full ${tipo.corHover}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(tipo.path);
                    }}
                  >
                    Emitir {tipo.nome}
                  </Button>
                </div>
              </Card>
            </div>
          );
        })}
      </div>
      
      {/* Informações adicionais */}
      <Card>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Sobre os Tipos de Nota Fiscal
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">NFe</h3>
            <p className="text-gray-600 dark:text-gray-400">
              Nota Fiscal Eletrônica para produtos destinados a empresas. Gera XML e chave de acesso.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">NFSe</h3>
            <p className="text-gray-600 dark:text-gray-400">
              Nota Fiscal de Serviços Eletrônica para prestação de serviços. Integrada com a Receita Federal.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">NFCe</h3>
            <p className="text-gray-600 dark:text-gray-400">
              Nota Fiscal de Consumidor Eletrônica para vendas presenciais. Impressão simplificada.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}

